// typeof any so that it we don't have to cast when comparing a result to the error object
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/errorObject.js
// module id = 12
// module chunks = 1